.customer-orders__search-input-container {
  width: 100%;

  @media screen and (min-width: 600px) {
    width: 70%;
  }

  @media screen and (min-width: 1024px) {
    width: 50%;
  }
}
